<script lang="ts">

    import { Col, Container, Row } from "sveltestrap";
    import LoginForm from "../Components/LoginForm.svelte";

</script>

<div class="login-view">
    <Container>
        <Row class="justify-content-center">
            <Col xs="12" sm="8" md="6" lg="4">
                <LoginForm />
            </Col>
        </Row>
    </Container>
    
</div>

<style type="scss">

    .login-view {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
        background-color: var(--color-primary);
    }

</style>

